import { render, staticRenderFns } from "./backlogs.vue?vue&type=template&id=0267e7d3&"
import script from "./backlogs.vue?vue&type=script&lang=js&"
export * from "./backlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports